import { Box, Divider, IconButton, Stack, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import DeleteIcon from '@mui/icons-material/Delete'
import ConfirmationDialog from 'components/ConfirmationDialog'
import { useBoolean } from 'hooks/useBoolean'
import { toast } from 'react-toastify'
import { useEffect } from 'react'
import { IInfoCenterFaq } from 'types/info-center/faq'
import { useDeleteFaqMutation } from 'services/info-center/faq'
import { Edit } from '@mui/icons-material'
import { DialogCreateFaq } from './dialog-create-faq'

type Props = {
  faq: IInfoCenterFaq
}

export const FaqCard = ({ faq }: Props) => {
  const { t } = useTranslation()
  const dialogCreateFaq = useBoolean(false)

  const dialogDeleteNotification = useBoolean(false)

  const [deleteFaq, { isSuccess, isError }] = useDeleteFaqMutation()

  useEffect(() => {
    if (isSuccess) {
      toast.success(t('operation-success'))
    }

    if (isError) {
      toast.success(t('operation-failure'))
    }
  }, [isSuccess, isError, t])

  return (
    <>
      {dialogCreateFaq.isTrue && (
        <DialogCreateFaq onClose={dialogCreateFaq.setFalse} faq={faq} />
      )}
      <ConfirmationDialog
        open={dialogDeleteNotification.isTrue}
        onClose={dialogDeleteNotification.setFalse}
        onConfirm={() => deleteFaq({ id: faq.id })}
        text={t('are-you-sure-you-want-to-delete')}
      />

      <Box
        bgcolor="#FFFFFF"
        padding={2}
        borderRadius={1}
        marginTop={2}
        borderLeft={4}
        borderColor="primary.main"
        boxShadow={2}
      >
        <Stack direction="row" spacing={1}>
          <Stack minWidth={0} flexGrow={1} spacing={2}>
            <Stack direction="row" spacing={4}>
              <Box>
                <Typography variant="body2" fontWeight="bold">
                  {t('question')}
                </Typography>
                <Typography variant="body2">{faq.question}</Typography>
              </Box>

              <Box>
                <Typography variant="body2" fontWeight="bold">
                  {t('answer')}
                </Typography>
                <Typography variant="body2">{faq.answer}</Typography>
              </Box>
            </Stack>
          </Stack>
          <Divider orientation="vertical" flexItem />
          <Stack spacing={3} flexShrink={0}>
            <IconButton
              onClick={dialogDeleteNotification.setTrue}
              sx={{ width: 40 }}
            >
              <DeleteIcon color="error" />
            </IconButton>
          </Stack>
          <IconButton onClick={dialogCreateFaq.setTrue} sx={{ width: 40 }}>
            <Edit />
          </IconButton>
        </Stack>
      </Box>
    </>
  )
}
